export default "__VITE_ASSET__ChkGo4xp__"